module.exports = __webpack_public_path__ + "static/media/Desktop3.8d1f98f2.jpg";